import type { NavMesh } from '@recast-navigation/core';
import { Group, Vector2 } from 'three';

export class Course extends Group {
  /**
   * Indicates whether this object is a course.
   */
  isCourse: boolean = true;

  /**
   * Location coordinates for the pivot point of the course in Longitude/Latitude format (X/Y) format.
   */
  location: Vector2;

  /**
   * The nav mesh associated with this course.
   */
  navMesh: NavMesh;

  constructor(location: Vector2, navMesh: NavMesh) {
    super();
    this.name = 'Course';
    this.navMesh = navMesh;
    this.location = location;
  }

  // Override the copy method to ensure correct copying behavior
  copy(source: Course, recursive?: boolean): this {
    super.copy(source, recursive);
    this.navMesh = source.navMesh;
    this.isCourse = source.isCourse;
    this.name = source.name;
    this.location = source.location.clone();
    return this;
  }
}
